import SectionHeading from './SectionHeading';
import { useInView } from '../hooks/useInView';
import { experience } from '../data/resume';

export default function Experience() {
  const [ref, isVisible] = useInView();

  return (
    <section id="experience" className="section" ref={ref}>
      <div className={`reveal ${isVisible ? 'reveal--visible' : ''}`}>
        <SectionHeading number="01" title="Work Experience" />

        <div className="timeline">
          {experience.map((job, index) => (
            <article key={job.company} className="timeline-item">
              <div className="timeline-marker">
                <span className="timeline-dot" />
                {index < experience.length - 1 && <span className="timeline-connector" />}
              </div>

              <div className="timeline-content">
                <div className="timeline-header">
                  <div>
                    <h3 className="timeline-role">{job.role}</h3>
                    <p className="timeline-company">
                      {job.company}
                      <span className="timeline-location"> · {job.location}</span>
                    </p>
                  </div>
                  <time className="timeline-period">{job.period}</time>
                </div>

                <ul className="timeline-list">
                  {job.highlights.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>

                <div className="tag-list">
                  {job.stack.map((tech) => (
                    <span key={tech} className="tag">{tech}</span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
